module.exports = __webpack_public_path__ + "img/T4-C-xh_8.7792cc14.png";